<template>
    <div class="position-relative btn-cover">
        <div class="d-flex flex-row text-truncate mb-1 align-content-center flex-wrap">
            <b-button variant="light" class="d-flex flex-row"
                      @blur="hide"
                      @click="triggerShow">
                <h4 class="mb-0">{{ currentConfig.title }}</h4>
                <i v-if="!singleMode" class="fa-solid ml-2 m-tb-auto" :class="openCard?'fa-caret-up':'fa-caret-down'"></i>
            </b-button>
            <template v-if="changed">
                <div v-if="!hideChangedLabel" class="m-tb-auto ml-1">(已编辑)</div>
                <div v-else class="ml-auto"></div>
                <div class="d-flex flex-row ml-1 m-tb-auto">
                    <b-dropdown v-if="!currentConfig.isClear" text="保存" class="" boundary="window"
                                style="height: 1.5rem">
                        <b-dropdown-item @click="clickToSaveConfig">保存{{ configTypeName }}</b-dropdown-item>
                        <b-dropdown-item @click="clickToNewConfig">另存为新{{ configTypeName }}</b-dropdown-item>
                    </b-dropdown>
                    <b-button v-else class="ml-1 m-tb-auto" style="height: 1.5rem;padding: .1rem .2rem"
                              @click="clickToNewConfig">
                        另存为
                    </b-button>
                    <b-button class="ml-1 m-tb-auto" style="height: 1.5rem;padding: .1rem .2rem"
                              @click="clickToReset">
                        重置
                    </b-button>
                </div>
            </template>

            <div class="ml-auto">
                <slot></slot>
            </div>
        </div>

        <div v-show="openCard" class="position-absolute card card-div" tabindex="-1" @mousedown="eventPrevent">
            <b-card v-if="queryLoading && configurationList.length===0">
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
            <div v-else class="w-100 h-100 d-flex flex-column p-1">
                <div id="card-item-list" class="overflow-auto m-1 card-view-div">
                    <template v-for="(group,i) of groupedConfigurationList">
                        <div :key="i" class="w-100" v-if="group.list.length>0">
                            <h5 class="position-sticky mb-0 top bg-white">{{ group.label }}{{ configTypeName }}</h5>
                            <template v-for="(item,index) of group.list">
                                <div :key="index" class="view-item d-flex flex-row align-content-center flex-wrap"
                                     :class="isCurrentConfig(item) ? 'view-item-active':''"
                                     @click="loadConfig(item)">
                                    <div class="view-item-icon mr-1 pl-1">
                                        <i v-if="isCurrentConfig(item)" class="fa-solid fa-check"></i>
                                    </div>
                                    {{ item.title }}
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
                <b-button-group vertical>
                    <mini-button variant="light" class="w-100 mt-auto"
                                 @btnClick="clickToNewConfig(true)">
                        <i class="fa-solid fa-plus"></i>
                        新增{{ configTypeName }}
                    </mini-button>
                    <mini-button variant="light" class="w-100" @btnClick="$refs.configManage.showModal()">
                        <i class="fa-solid fa-gear"></i>
                        {{ configTypeName }}管理
                    </mini-button>
                </b-button-group>
            </div>
        </div>

        <re-b-modal ref="titleInput" :header="isReNew?`另存为新${configTypeName}`:`新建${configTypeName}`"
                    no-auto-hide
                    @hide="clearMsg"
                    @ok="submitNewConfig">
            <mini-input :value.sync="title" :label="`${configTypeName}名称`" type="input" require
                        :invalid-show="msg"></mini-input>
            <mini-input :value.sync="shareGlobal" :label="`${configTypeName}可见范围`" type="radio-select"
                        :options="shareOptions"></mini-input>
        </re-b-modal>

        <re-b-modal ref="configManage" :header="`${configTypeName}管理`" no-ok-button>
            <div class="d-flex flex-column">
                <template v-for="(group,i) of groupedConfigurationList">
                    <div :key="i" class="w-100" v-if="group.notEmpty">
                        <h5 class="position-sticky mb-0 top bg-white">{{ group.label }}{{ configTypeName }}</h5>
                        <template v-for="(item,index) of group.list">
                            <div class="d-flex flex-row mb-1 ml-2" v-if="item.id" :key="index">
                                <mini-input type="checkbox" class="m-auto"
                                            :value.sync="selectedIds[item.id]"
                                            without-label></mini-input>
                                <common-e-d-input class="flex-grow-1" :value="item.title"
                                                  @save="doRename(item.id, $event)"
                                                  @delete="doDelete(item)"></common-e-d-input>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <empty-list-info v-if="configurationList.length===0"></empty-list-info>
            <template #footer>
                <b-button-group>
                    <mini-button @btnClick="importConfigs">Import</mini-button>
                    <mini-button @btnClick="copyConfigs">Export/Copy</mini-button>
                </b-button-group>
            </template>
        </re-b-modal>

        <re-b-modal ref="jsonInput" header="粘贴配置" @ok="parseConfigJson(copiedJsonStr)">
            <mini-input type="textarea" class="m-auto"
                        :value.sync="copiedJsonStr"
                        without-label></mini-input>
        </re-b-modal>

        <re-b-modal ref="jsonView" header="JSON查看" ok-label="上传" @ok="uploadJson">
            <vue-json-pretty :data="copiedJson" :deep="5"></vue-json-pretty>
        </re-b-modal>
    </div>
</template>

<script>

import queryVisibleConfigurationsMixin from "@/components/jsc/query-visible-configurations-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import jsonShareCenterMixins from "@/mixin/common/json-share-center-mixins";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import _ from "lodash";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import CommonEDInput from "@/components/common/inputs/CommonEDInput.vue";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo.vue";
import VueJsonPretty from 'vue-json-pretty';

const MAX_TITLE_SIZE = 26;
const SHARE_GROUP = [
    {value: 1, text: '个人'},
    {value: 20, text: '公共'},
];
export default {
    name: "LayoutConfigurationTitle",
    components: {EmptyListInfo, CommonEDInput, MiniInput, ReBModal, MiniButton, VueJsonPretty},
    mixins: [emCommonUtilMixin, jsonShareCenterMixins, queryVisibleConfigurationsMixin],
    props: {
        hideChangedLabel: {
            type: Boolean,
            default: false
        },
        emptyConfigTitle: {
            type: String,
            default: '全部'
        },
        configTypeName: {
            type: String,
            default: '视图'
        },
        singleMode: Boolean,
        noAutoGather: Boolean,
    },
    data() {
        return {
            emptyConfig: {
                title: this.emptyConfigTitle,
                isClear: true
            },
            currentConfig: null,
            configurationObject: null,
            currentConfigurationObject: null,
            openCard: false,

            brandNew: false,
            isReNew: false,
            title: null,
            shareGlobal: false,
            changed: false,
            msg: null,

            refreshFlag: new Date(),

            selectedIds: {},
            copiedJsonStr: null,
            copiedJson: null,
        }
    },
    computed: {
        currentTableFilter() {
            if (this.refreshFlag) {
                //
            }
            if (this.noAutoGather) {
                return JSON.parse(JSON.stringify(this.currentConfigurationObject));
            }
            return JSON.parse(JSON.stringify(this.$parent.gatherConfig()));
        },
        finalConfigurationList() {
            let temp = this.deepCopyObj(this.configurationList);
            let item = this.emptyConfig;
            if (temp instanceof Array) {
                temp.splice(0, 0, item);
            } else {
                temp = [item]
            }
            return temp;
        },
        groupedConfigurationList() {
            let tempList = [];
            for (let item of SHARE_GROUP) {
                let list = [];
                let count = 0;
                for (let c of this.finalConfigurationList) {
                    let level = c.shareLevel;
                    if (c.isClear) {
                        level = 1;
                    }
                    if (level === item.value) {
                        list.push(c);
                        if (!c.isClear) {
                            count++;
                        }
                    }
                }
                tempList.push({
                    label: item.text,
                    notEmpty: count > 0,
                    list: list,
                })
            }
            return tempList;
        },
        shareOptions() {
            return [
                {text: `个人${this.configTypeName}(仅自己可见)`, value: false},
                {text: `公共${this.configTypeName}(全局可见)`, value: true},
            ]
        },
    },
    watch: {
        currentTableFilter: {
            handler() {
                // console.log('diff', this.currentTableFilter, this.configurationObject)
                this.changed = !_.isEqual(this.currentTableFilter, this.configurationObject);
            },
            deep: true
        },
        configurationObject: {
            handler() {
                // console.log('diff', this.currentTableFilter, this.configurationObject)
                this.changed = !_.isEqual(this.currentTableFilter, this.configurationObject);
            },
            deep: true
        },
        title() {
            if (this._strLengthZh2(this.title) > MAX_TITLE_SIZE) {
                this.msg = `名称应该不超过${MAX_TITLE_SIZE}个字符`;
            }
        },
    },
    created() {
        this.currentConfig = this.emptyConfig;
    },
    methods: {
        triggerShow() {
            if (this.singleMode) {
                this.openCard = false;
                return;
            }
            this.openCard = !this.openCard;
            if (this.openCard) {
                this.getRemoteData();
            }
        },
        clickToNewConfig(brandNew = false) {
            this.brandNew = brandNew;
            this.isReNew = true;
            this.openCard = false;
            this.$refs.titleInput.showModal();
        },
        clickToSaveConfig() {
            this.isReNew = false;
            this.$bvModal.msgBoxConfirm(`当前${this.configTypeName}原有配置会被覆盖`, {
                title: `确定覆盖原有${this.configTypeName}吗？`,
                headerBgVariant: 'light',
                headerClass: 'text-dark',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: '是',
                cancelTitle: '否',
                footerClass: 'p-2',
                hideHeaderClose: false
            }).then(confirm => {
                if (confirm) {
                    this.submitSave();
                }
            });
        },
        clickToReset() {
            this.loadConfig(this.currentConfig);
        },
        submitNewConfig() {
            if (!this.hasCode(this.title)) {
                return;
            } else {
                if (this._strLengthZh2(this.title) > MAX_TITLE_SIZE) {
                    return;
                }
            }
            if (this.currentTableFilter == null) {
                this.$message.warning(`请先修改${this.configTypeName}`);
                return;
            }
            this.clearMsg();
            let json = JSON.stringify(this.currentTableFilter);
            let form = {
                moduleCode: this.moduleCode,
                identifyCode: this.identifyCode,
                key: this.keyCode,
                title: this.title,
                configuration: json,
                isNew: this.isReNew,
                shareGlobal: this.shareGlobal,
            };
            let self = this, title = this.title;
            this.$_upload(form).then(() => {
                this.$message.success('上传成功');
                this.$emit('submitted');
                this.$refs.titleInput.hide();
                this.getRemoteData().then(() => {
                    for (let item of this.configurationList) {
                        if (item.title === title) {
                            self.loadConfig(item);
                        }
                    }
                });
                this.title = null;
            }).catch(e => {
                this.msg = e.response.data.message;
            });
        },
        clearMsg() {
            this.msg = null;
        },
        submitSave() {
            let id = this.currentConfig.id;
            if (id) {
                if (this.currentTableFilter == null) {
                    this.$message.warning(`请先修改${this.configTypeName}`);
                    return;
                }
                this.$_upload({
                    id: id,
                    configuration: JSON.stringify(this.currentTableFilter),
                }).then(() => {
                    this.$message.success('操作成功');
                    this.$emit('submitted');
                    this.getRemoteData();
                    this.configurationObject = this.currentTableFilter;
                    this.title = null;
                });
            }
        },
        loadConfig(item) {
            if (item == null) {
                item = this.emptyConfig;
            }
            this.openCard = false;
            this.currentConfig = item;
            let config = item.isClear ? null : item;
            if (this.currentConfig.configuration) {
                this.configurationObject = JSON.parse(this.currentConfig.configuration);
            } else {
                this.configurationObject = null;
            }
            this.$emit('loadConfig', config);
        },
        hide() {
            this.openCard = false;
        },
        eventPrevent(event) {
            event.preventDefault();
        },
        doRename(id, title) {
            if (!this.hasCode(title)) {
                this.$message.warning('名称不能为空');
                return;
            } else {
                if (this._strLengthZh2(title) > MAX_TITLE_SIZE) {
                    this.$message.warning(`名称应该不超过${MAX_TITLE_SIZE}个字符`);
                    return;
                }
            }
            this.rename(id, title).then(() => {
                this.$message.success("操作成功");
                this.getRemoteData().then(() => {
                    if (this.currentConfig.id === id) {
                        this.currentConfig.title = title;
                    }
                });
            }).catch(e => {
                this.$message.error(e.response.data.message);
            });
        },
        doDelete(item) {
            this.deleteById(item).then(() => {
                this.$message.success("操作成功");
                this.getRemoteData().then(() => {
                    if (this.currentConfig.id === item.id) {
                        this.currentConfig = this.finalConfigurationList[0];
                    }
                });
            });
        },
        //------------------------------------------------------
        isCurrentConfig(item) {
            if (this.currentConfig.id) {
                return item.id === this.currentConfig.id;
            } else {
                return item.title === this.currentConfig.title;
            }
        },
        configChanged() {
            this.refreshFlag = new Date();
        },
        //------------------------------------------------------
        copyConfigs() {
            let ids = Object.keys(this.selectedIds);
            if (ids.length === 0) {
                this.$message.warning('You should select first');
                return;
            }
            let tempList = [];
            for (let item of this.configurationList) {
                if (this.selectedIds[item.id]) {
                    tempList.push(item);
                }
            }
            navigator.clipboard.writeText(JSON.stringify(tempList));
            this.$message.success("Copied");
        },
        importConfigs() {
            if (navigator.clipboard) {
                navigator.clipboard.readText().then(json => {
                    this.parseConfigJson(json);
                });
            } else {
                this.$refs.jsonInput.showModal();
            }
        },
        parseConfigJson(json) {
            try {
                this.copiedJson = JSON.parse(json);
                this.$refs.jsonView.showModal();
            } catch (error) {
                this.$message.error('error' + error);
            }
        },
        uploadJson() {
            this.$store.dispatch('api/post', {
                url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/jscConfiguration/upload/copied`,
                data: this.copiedJson
            }).then(() => {
                this.$message.success("Upload success");
                this.getRemoteData();
                this.copiedJson = null;
            });
        },
    }
}
</script>

<style scoped>
.btn-cover {
    width: max-content;
}

.card-div {
    top: 100%;
    left: 0;
    height: min-content;
    width: 200px;
    z-index: 1000;
    background-color: #FFFFFF;
    border-radius: 5px;
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.card-view-div {
    max-height: 200px;
}

.view-item {
    cursor: pointer;
    height: 1.5rem;
}

.view-item:hover {
    background-color: #f1f4f6;
}

.view-item-active {
    background-color: #c1e4fe !important;
}

.view-item-icon {
    width: 1.5rem;
    color: #2061c8;
}

.dropdown >>> .dropdown-toggle {
    padding: .1rem .2rem !important;
}

.dropdown >>> .dropdown-item:hover {
    background-color: #f1f4f6;
    color: unset;
}

.btn-cover >>> .btn-secondary {
    background-color: #f1f4f6;
    border-color: #f1f4f6;
    color: #636363;
}

#card-item-list::-webkit-scrollbar {
    width: 1px;
    background-color: transparent;
}

#card-item-list::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background-color: rgb(128, 128, 128);
}
</style>
